(function () {
  "use strict";

  const base = "https://automatizador-cd144fb7548b.herokuapp.com";

  const load = function (src, attrs) {
    // idempotencia: si ya está inyectado, no lo dupliques
    if (document.querySelector('script[src="' + src + '"]')) return;
    const s = document.createElement("script");
    s.src = src;
    for (const k in attrs) s.setAttribute(k, attrs[k]);
    document.head.appendChild(s);
  };

  load(base + "/static/js/checkout-interceptor-v3.js", {
    "data-api-url": base,
    "data-checkout-url": base,
    "data-debug": "true"
  });

  load(base + "/static/js/paypal-express-landing.js", {
    "data-api-url": base,
    "data-checkout-url": base
  });
})();